import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./components/App";
import rootReducer from "./reducers";
import { fetchMemes } from "./actions";

const store = configureStore({ reducer: rootReducer });
store.dispatch(fetchMemes());

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>
);
